import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { Case } from "../_types/case";
import { CaseNote } from "../_types/case-note";
import { CaseServiceSignature } from "../_types/case-service-signature";

@Injectable({
    providedIn: 'root',
})
export class CasesServicesSignaturesService extends Service<CaseServiceSignature> {
    public override type = 'caseServiceSignatures';
    public override url = 'attendance/caseServiceSignatures';
}
